<script lang="ts" setup>
import Image from 'primevue/image';

const props = defineProps<{
  src: string;
  alt?: string;
  imageClass?: string;
  width?: string;
  height?: string;
  preview?: boolean;
}>();
</script>

<template>
  <Image
    :src="props.src"
    :pt="{ image: { alt: props.alt, width: props.width, height: props.height } }"
    :image-class="props.imageClass"
    :preview="props.preview"
  />
</template>
